import fetcher from '../../helpers/fetcher';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { unwrapDataResponse } from '../../utils/unwrapDataResponse';
import type { AveragePriceParams, PriceQueryParams, PriceResponse } from '../../types/price';

export class PriceService {
  private consumerPriceUrl = ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE;
  private analysisService = ENVIRONMENT_CONFIG.ANALYSIS_SERVICE;

  async getPrices(params: PriceQueryParams = {}): Promise<PriceResponse> {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params.search) queryParams.append('search', params.search);
    if (params.productRefId) queryParams.append('productRefId', params.productRefId);
    if (params.priceRecordId) queryParams.append('priceRecordId', params.priceRecordId.toString());

    const response = await fetcher.get(
      API_ENDPOINTS.PRICE.GET_PRICE_LIST,
      queryParams,
      undefined,
      this.consumerPriceUrl
    );
    return unwrapDataResponse<PriceResponse>(response.data);
  }

  async getAveragePrice(params: AveragePriceParams): Promise<{ averagePrice: number }> {
    const queryParams = new URLSearchParams();

    // Map AveragePriceParams to backend SingleProductAveragePriceQueryDto
    if (params.productId) queryParams.append('productId', params.productId);
    if (params.fromDate) queryParams.append('startTime', params.fromDate.toString());
    if (params.toDate) queryParams.append('endTime', params.toDate.toString());
    if (params.department) queryParams.append('department', params.department);
    if (params.city) queryParams.append('city', params.city);

    if (!this.analysisService) {
      throw new Error('Analysis service URL is not configured');
    }

    const response = await fetcher.get(
      API_ENDPOINTS.ANALYSIS.GET_PUBLIC_PRODUCT_AVERAGE,
      queryParams,
      undefined,
      this.analysisService
    );
    
    return unwrapDataResponse<{ averagePrice: number }>(response.data);
  }
}

export const priceService = new PriceService();
